import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import IconDefs from './IconDefs'
import Header from './Header'
import Footer from './Footer'
import { useAtzScripts } from './useAtzScripts'
import { applyRouteMeta } from '@/lib/seo'

export default function Layout() {
  const loc = useLocation()
  const navigate = useNavigate()

  // Canonical URLs always end in "/". The server 301s direct hits; this
  // catches in-app navigations (and the Vite dev server).
  useEffect(() => {
    if (!loc.pathname.endsWith('/')) {
      navigate(`${loc.pathname}/${loc.search}${loc.hash}`, { replace: true })
    }
  }, [loc.pathname, loc.search, loc.hash, navigate])

  useEffect(() => {
    document.documentElement.setAttribute('data-accent', 'standard')
    document.documentElement.setAttribute('data-font', 'newsreader')
  }, [])

  useEffect(() => {
    if (!loc.hash) window.scrollTo(0, 0)
  }, [loc.pathname, loc.hash])

  useEffect(() => {
    applyRouteMeta(loc.pathname)
  }, [loc.pathname])

  useAtzScripts(loc.pathname)

  return (
    <>
      <IconDefs />
      <Header />
      <Outlet />
      <Footer />
    </>
  )
}
